import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import SelectTemplate from './selectTemplate';
import CreatableSelect from 'react-select/creatable';
import { useDispatch } from 'react-redux';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import Loader from '../../shared/component/Loader';
import DateTimePicker from '../../shared/controls/form/dateTimePicker';
import { leadInputData } from '../../shared/constants';

const MassEmail = ({ selectedOptions, handleClose, handleChange, selectedRows, module }) => {
  const [formData, setFormData] = useState([]);
  const [formEdited, setFormEdited] = useState(false);
  const [selectedToEmails, setSelectedToEmails] = useState([]);
  const [selectedFromEmails, setSelectedFromEmails] = useState([]);
  const [selectedReplyToEmails, setSelectedReplyToEmails] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const emailString = process.env.REACT_APP_FROM_ADDRESSES || '';
  const emailList = emailString.split(',').filter((email) => email.trim() !== '');
  const fromAddressOptions = emailList.map((email) => ({
    value: email,
    label: email,
  }));
  const dispatch = useDispatch();
  const handleSave = (data) => {
    setTemplateData(data);
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sendOption: 'option1',
    }));
  }, []);

  const handleSubmit = (formData) => {
    setLoading(true);
    const selectedIds = templateData.map((row) => row.id); // Extract IDs from templateData
    const moduleIds = selectedRows.map((row) => row.id);
    const templateIds = selectedIds.join(',');
    const formDataCopy = { ...formData };
    const modifiedSelectedRows = selectedRows.map((row) => ({
      ...row,
      optout: row.emailOptOut ? 1 : 0,
    }));
    // Delete the sendOption key from the copy
    delete formDataCopy.sendOption;
    const updatedFormData = {
      ...formDataCopy,
      module: module,
      moduleId: moduleIds.join(','),
      emailUserData: modifiedSelectedRows,
      templateId: templateIds ? templateIds : '',
      scheduledTime: formData.scheduledTime ? formData.scheduledTime : null,
      status: formData.scheduledTime ? 'Scheduled' : 'Pending',
      subject: templateData[0]?.subject,
    };
    apiServices
      .sendMassEmail(updatedFormData)
      .then((response) => {
        if (response.status === 200) {
          handleClose();
          dispatch(
            fetchDataAndUpdateStore({
              key: `massEmail${module}Sent`,
              inputData: {
                ...leadInputData,
                module: module,
                columnName: 'createdDateTime',
                status: '',
                pageNumber: module === 'Contact' ? 50 : leadInputData.pageNumber,
              },
            })
          );
          setLoading(false);
          setFormData([]);
          toast.success('Mass Email Sent Successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
          const errorMessages = [];
          for (const key in response.errors) {
            if (response.errors.hasOwnProperty(key)) {
              const messages = response.errors[key];
              errorMessages.push(...messages);
            }
          }
          errorMessages.forEach((errorMessage) => {
            toast.error(errorMessage, { position: 'top-right' });
          });
        }
      })

      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  };

  const handleChangeForm = (e) => {};

  const [showSelectTemplatePopup, setSelectTemplatePopup] = useState(false);

  const openSelectTemplatePopup = () => {
    setSelectTemplatePopup(true);
  };

  const closeSelectTemplatePopup = () => {
    setSelectTemplatePopup(false);
  };

  const [selectedOption, setSelectedOption] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  const handleEmailChange = (selectedOptions, field) => {
    const emails = selectedOptions.map((option) => option.value);

    // Update formData based on the field (toAddress or fromAddress)
    setFormData((prev) => ({
      ...prev,
      [field]: emails.join('; '), // Combine selected emails into a single string
    }));
    setFormEdited(true);

    // Update the corresponding selectedEmails state
    if (field === 'toAddress') {
      setSelectedToEmails(selectedOptions);
    } else if (field === 'fromAddress') {
      setSelectedFromEmails(selectedOptions);
    } else if (field === 'replyToAddress') {
      setSelectedReplyToEmails(selectedOptions);
    }
  };
  const isSendButtonDisabled = !formData.fromAddress || templateData.length === 0;
  useEffect(() => {
    if (selectedRows && selectedRows.length > 0) {
      // Extract emails from selectedRows
      const emails = selectedRows
        .map((row) => row.email) // Assuming each row has an `email` field
        .filter((email) => email); // Filter out undefined or empty emails

      // Transform emails into the format expected by CreatableSelect
      const formattedEmails = emails.map((email) => ({
        label: email,
        value: email,
      }));

      // Set initial selectedEmails
      setSelectedToEmails(formattedEmails);

      // Set initial formData.toAddress
      setFormData((prev) => ({
        ...prev,
        toAddress: emails.join('; '), // Combine emails into a single string
      }));
    }
  }, [selectedRows]);
  const handleSelect = (selected) => {
    setSelectedOption(selected);
    setErrorMsg(''); // Clear error message on selection
  };

  // Handle radio button change
  const handleRadioChange = (event) => {
    const { value } = event.target;
    setFormData((prev) => ({
      ...prev,
      sendOption: value, // Update the selected radio button
    }));
  };

  // Handle date and time change
  const handleDateTime = (e) => {
    const dataTime = e.target.value;
    setFormData({
      ...formData,
      scheduledTime: dataTime,
    });
    setFormEdited(true);
  };

  // ***********************send state*************

  return (
    <>
      {loading && <Loader />}
      <Formik>
        <form>
          <div id="genricPopup">
            <div className="popup-backdrop">
              <div className="popup ">
                {/* Popup Header */}
                <div className="popup-header">
                  <h4 className="popup-title">Mass Email</h4>
                  <button className="custom-btn-close" onClick={handleClose}></button>
                </div>

                {/* Popup Body */}
                <div className="popup-body">
                  <div className="popup-content-block custHeightMassMail">
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="input-container">
                          <label>To</label>
                          <CreatableSelect
                            isMulti
                            name={'toAddress'}
                            value={selectedToEmails}
                            onChange={(selectedOptions) =>
                              handleEmailChange(selectedOptions, 'toAddress')
                            }
                            placeholder="Select options..."
                            isDisabled={true}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-12 mt-2">
                        {' '}
                        <div className="flex-div align-items-center">
                          <div className="flex-div align-items-center custWd">
                            <label className="mb-0">Template</label>
                            <button
                              className="btn btn-primary ms-3"
                              type="button"
                              onClick={openSelectTemplatePopup}
                            >
                              Select Template
                            </button>
                          </div>
                          {templateData.length > 0 && (
                            <div className="selTempName">
                              <span className="selTempNameChip">
                                {templateData[0]?.name}
                                <img src="../assets/images/close.svg" alt="" width="11px" />
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12  col-md-12"></div>

                      <div className="col-12 col-md-12">
                        <div className="input-container">
                          <label>From</label>
                          <CreatableSelect
                            name={'emailId'}
                            isMulti
                            placeholder={''}
                            onChange={(selectedOptions) =>
                              handleEmailChange(selectedOptions, 'fromAddress')
                            }
                            options={fromAddressOptions}
                            createOptionPosition="first"
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderRadius: '5px',
                                borderColor: state.isFocused ? '#365397' : base.borderColor,
                                borderWidth: state.isFocused ? '1px' : base.borderWidth,
                                boxShadow: state.isFocused
                                  ? '0 0 5px rgba(0, 86, 179, 0.3)'
                                  : 'none',
                                transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                '&:hover': {
                                  borderColor: '#365397',
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: '5px',
                                zIndex: 99999,
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected
                                  ? '#DEEBFF'
                                  : state.isFocused
                                    ? '#DEEBFF'
                                    : base.backgroundColor,
                                color: state.isSelected
                                  ? '#222'
                                  : state.isFocused
                                    ? '#222'
                                    : base.color,
                                cursor: 'pointer',
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-12">
                        <div className="radioBtnContainer">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio1"
                              value="option1"
                              checked={formData.sendOption === 'option1'}
                              onChange={handleRadioChange}
                            />
                            <label className="form-check-label" htmlFor="inlineRadio1">
                              Send Immediately
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio2"
                              value="option2"
                              checked={formData.sendOption === 'option2'}
                              onChange={handleRadioChange}
                            />
                            <label className="form-check-label" htmlFor="inlineRadio2">
                              Schedule Later
                            </label>
                          </div>

                          {/* Conditionally Render DateTimeBox */}
                          {formData.sendOption === 'option2' && (
                            <div className="col-12 col-sm-12 col-md-8">
                              <div className="input-container">
                                <DateTimePicker
                                  value={formData.scheduledTime}
                                  onChange={handleDateTime}
                                  name="reminder"
                                  placeholder="Select Schedule Date & Time"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Popup Footer */}
                <div className="popup-footer">
                  <button type="button" className="cancel-lead ld-btn" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="save-lead ld-btn"
                    onClick={() => handleSubmit(formData)}
                    disabled={isSendButtonDisabled || loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    {loading ? 'Sending...' : 'Send'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Formik>
      {showSelectTemplatePopup && (
        <SelectTemplate
          handleClose={closeSelectTemplatePopup}
          handleSubmit={handleSave}
          module={module}
        />
      )}
    </>
  );
};
export default MassEmail;
